export default {
  /**
   * 获取OSS上传签名
   */
  // 获取阿里云上传视频图片的action地址
  getOSSsignature: '/common/getOSSsignature',

  // 获取阿里云上传视频图片的action地址(视频十五分钟)
  getOSSsignatureRam: '/common/getOSSsignatureRam',

  // 获取base64图片
  getAmBase64: '/bygDeadManV2/getQrcodeBase64',

  // 获取单位名称
  findAppInfoById: '/bygApp/findAppInfoById',

  // 设置背景图文案
  setPosterName: '/bygDeadManV2/editPosterUrlById',

  // 设置背景图文案竖版
  setPosterNameCode: '/bygDeadManV2/editPosterVerticalUrlById',

  // 认领码背景
  editClaimCodeById: '/bygDeadManV2/editClaimCodeById',

  //纪念堂操作权限发短信
  editUpdateStateSendCode: '/bygDeadManV2/editUpdateStateSendCode',

  //纪念堂冻结管理发短信
  editSpaceFrozenSendCode: '/bygDeadManV2/editSpaceFrozenSendCode',

  //纪念堂上传权限发短信
  editUploadStateSendCode: '/bygDeadManV2/editUploadStateSendCode',

  //订单退款验证码
  payRefundSendCode: '/bygOrder/payRefundSendCode',

}



// WEBPACK FOOTER //
// ./src/api/Common/urls.js